const QUOTE_SUBMITTED_MESSAGE_TYPE = 'uwQuoteSubmitted';

interface QuoteSubmittedMessage {
  type: typeof QUOTE_SUBMITTED_MESSAGE_TYPE;
  basketId: string;
}

/**
 * Tells the embedding page (e.g. the Partner App web's iframe wrapper) that
 * the quote has been submitted.
 *
 * The target origin is deliberately `'*'`: the payload must stay
 * non-sensitive. Who may embed this app is a framing concern
 * (`frame-ancestors`), and the listener must validate `event.origin` and
 * `event.source` itself.
 *
 * Does nothing when the app isn't framed (top-level load, React Native
 * WebView), where `window.parent === window`.
 */
const notifyParentQuoteSubmitted = (basketId: string) => {
  if (window.parent === window) {
    return;
  }

  const message: QuoteSubmittedMessage = {
    type: QUOTE_SUBMITTED_MESSAGE_TYPE,
    basketId,
  };
  window.parent.postMessage(message, '*');
};

export { QUOTE_SUBMITTED_MESSAGE_TYPE, notifyParentQuoteSubmitted };
